import React from 'react'
import { Collapse, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ActionButton } from '@emerald-works-nova/components'
import { useDispatch, useSelector } from 'react-redux'
import { UserDeleteSlice } from '../../../../reducers'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    marginBottom: spacing(2),
    paddingBlock: spacing(3),
    paddingInline: spacing(4),
    background: palette.grey.lighter,
    border: `1px dashed ${palette.grey.dark}`,
    borderRadius: 4
  }
}))

const UserMultipleDeleteResults = () => {
  const classes = useStyles()
  const { isVisible, successCount, warningsCount, errorsCount, total } = useSelector(UserDeleteSlice.selectors.selectResults)
  const reportUrl = useSelector(UserDeleteSlice.selectors.selectReportUrl)
  const dispatch = useDispatch()

  const handleDismiss = () => {
    dispatch(UserDeleteSlice.actions.reset())
  }

  return (
    <Collapse in={!!isVisible}>
      {isVisible && (
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          className={classes.root}
        >
          <Grid item xs>
            <Typography variant='caption'>
              <strong>
                Bulk Delete of Users Log
              </strong>
              <br />
              Successfully deleted users: {successCount}
              <br />
              Users deleted with warnings: {warningsCount}
              <br />
              Failed to delete: {errorsCount}
              <br />
              Total: {total}
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            container
            direction='column'
            alignItems='flex-end'
            spacing={2}
          >
            <Grid item>
              <ActionButton text='Dismiss' noBorder onClick={handleDismiss} />
            </Grid>
            <Grid item>
              <ActionButton
                text='Download CSV File'
                component='a'
                href={reportUrl}
                target='_blank'
                disabled={!reportUrl}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Collapse>
  )
}

export default UserMultipleDeleteResults
